import React, { FC, HTMLAttributes } from 'react';
import DealsSection from './DealsSection';
import { LegacyDeal } from '../../../../../../../interfaces/api/Deal';
import { CreateTicketOptions } from '../../../../../../../interfaces/api/Ticket';
import useTicket from '../../../../../../../hooks/api/useTicket';
import useContact from '../../../../../../../hooks/api/useContact';
import Contact, { CreateContactOptions } from '../../../../../../../interfaces/api/Contact';
import { withRouter } from 'react-router';

interface Props extends HTMLAttributes<HTMLDivElement> {
  deals: LegacyDeal[];
  loading: boolean;
  hidden?: boolean;
  siteId?: string;
  history?: any;
  style?: any;
}

const DealsSectionContainer: FC<Props> = ({ history, ...props }) => {
  const { create: createTicket } = useTicket();
  const { create: createContact } = useContact();

  const handleCreateTicket = async (allTicketOptions: CreateTicketOptions) => {
    const {
      newContactPhoneNumber,
      newContactEmail,
      newContactLastname,
      newContactFirstname,
      ...ticketOptions
    } = allTicketOptions;

    if (!ticketOptions.associatedContactId) {
      const contact = await createNewContact(
        newContactLastname,
        newContactFirstname,
        newContactPhoneNumber,
        newContactEmail
      );

      ticketOptions.associatedContactId = contact.id;
    }

    ticketOptions.siteId = props.siteId;

    const ticket = await createTicket(ticketOptions);

    history?.push(`/dashboard/tickets/${ticket.id}`);
  };

  const createNewContact = async (
    lastname?: string,
    firstname?: string,
    phoneNumber?: string,
    email?: string
  ): Promise<Contact> => {
    if (!props.siteId) {
      throw new Error('Vous devez migrer le client pour pouvoir créer un contact');
    }

    if (!lastname || !firstname || !phoneNumber || !email) {
      throw new Error('Certains champs du nouveau contact sont invalides');
    }

    const contactOptions: CreateContactOptions = {
      lastname,
      firstname,
      phoneNumber,
      email,
      origin: 'Client existant',
      sendResetPasswordEmail: false,
    };

    return await createContact(props.siteId, contactOptions);
  };

  return <DealsSection onCreateTicket={handleCreateTicket} {...props} />;
};

export default withRouter(DealsSectionContainer);
